import React from 'react'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import { Link } from '@src/components/Link'
import clsx from 'clsx'
import messages from '../../messages'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => {
  return {
    HelpWrapper: {
      padding: theme.spacing(0, 0, 0, 0),
    },
    steps: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
    },
    sideBar: {
      color: theme.palette.grey[500],
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(8),
    },
    headingsecond: {
      fontSize: theme.typography.pxToRem(20),
    },
    divider: {},
    cursor: {
      cursor: 'pointer',
    },
    activelink: {
      cursor: 'pointer',
      color: theme.palette.common.black,
      '& hr': {
        backgroundColor: theme.palette.common.black,
      },
    },
    completedLink: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      '& hr': {
        backgroundColor: '#d8d8d8',
      },
    },
    disabledLink: {
      pointerEvents: 'none',
    },
  }
})
export interface SidebarItem {
  url?: string
  label: any
  active?: boolean
  completed?: boolean
  disabled?: boolean
}
export interface LeftNavigationProps {
  sidebarItems: SidebarItem[]
}
const LeftNavigation: React.FC<LeftNavigationProps> = (props) => {
  const classes = useStyles()
  const { sidebarItems } = props
  return (
    <Container className={classes.HelpWrapper}>
      {sidebarItems.map((item, index) => (
        <Grid
          className={clsx(classes.sideBar, {
            [classes.activelink]: item.active,
            [classes.completedLink]: item.completed,
          })}
          key={index}
        >
          <div className={classes.steps}>
            <FormattedMessage
              {...messages.CONF_NGSO_STEPS}
              values={{ stepNo: index + 1 }}
            />
          </div>
          <div>
            <Divider color="primary" className={classes.divider} />
          </div>
          <Link href={item.url!} passHref>
            <Grid
              onClick={(e) => {
                if (item.disabled) {
                  e.preventDefault()
                }
              }}
              container
              className={clsx(
                item.disabled
                  ? classes.disabledLink
                  : item.active
                    ? classes.activelink
                    : classes.cursor,
                classes.headingsecond,
                item.completed ? classes.completedLink : ''
              )}
            >
              {item.label}
            </Grid>
          </Link>
        </Grid>
      ))}
    </Container>
  )
}

export default LeftNavigation
